(() => {
  if(window.FanMomentStoryReveal){window.FanMomentStoryReveal.mount(document);return;}
  const mobile=window.matchMedia('(max-width: 767px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const roots = new Set();
  let ticking = false;
  function update() {
    ticking = false;
    if (reduceMotion.matches) return;
    roots.forEach(root => {
      if (!root.isConnected) { roots.delete(root); return; }
      const rect = root.getBoundingClientRect();
      const distance = Math.max(1, root.offsetHeight - window.innerHeight);
      const progress = Math.min(1, Math.max(0, -rect.top / distance));
      root.style.setProperty('--fm-story-progress', progress.toFixed(4));
    });
  }
  function requestUpdate() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  function selectMedia(root){
    const template=root.querySelector(mobile.matches?'[data-fm-story-mobile]':'[data-fm-story-desktop]')||root.querySelector('[data-fm-story-desktop]');
    const target=root.querySelector('[data-fm-story-media]');
    if(!template||!target||root.fmMediaTemplate===template)return;
    target.querySelectorAll('video').forEach(video=>video.pause());
    target.replaceChildren(template.content.cloneNode(true));root.fmMediaTemplate=template;
  }
  function mount(scope = document) { scope.querySelectorAll('[data-fm-story-reveal]').forEach(root => {roots.add(root);selectMedia(root);}); requestUpdate(); }
  window.FanMomentStoryReveal={mount};
  mobile.addEventListener('change',()=>roots.forEach(selectMedia));
  mount();
  addEventListener('scroll', requestUpdate, { passive: true });
  addEventListener('resize', requestUpdate, { passive: true });
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-fm-story-reveal]').forEach(root => roots.delete(root)));
})();
